import React from 'react';
import { icons, FileText } from 'lucide-react';

// Named line icons ('user-plus', 'map-pin', …) as used across the Stephanet catalog.
const pascal = s => s.split('-').map(p => p.charAt(0).toUpperCase() + p.slice(1)).join('');
// names lucide has since renamed (seeded data still carries the old ones)
const RENAMED = { 'help-circle': 'circle-help' };

export default function Icon({ name, size = 18, ...rest }) {
  const Cmp = (name && icons[pascal(RENAMED[name] || name)]) || FileText;
  return <Cmp size={size} {...rest} />;
}
